// extracted by mini-css-extract-plugin
export default {"logoBackground":"Navbars_logoBackground__+yUFv","logo":"Navbars_logo__PDr4e"};